// extracted by mini-css-extract-plugin
export default {"content":"review_content__-HsQq","confirm_check":"review_confirm_check__h-vGK","confirm_text":"review_confirm_text__hH6m0"};